/* import __COLOCATED_TEMPLATE__ from './timing-points.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class TimingPointsComponent extends Component
{
	@service store;
	@service errorManager;
	@service confirmation;

	@tracked isAddingNew = false;
	@tracked newTimingPointName = "";
	@tracked newTimingPointDescription = "";
	
	@action
	async saveNew(browserEvent)
	{
		browserEvent.preventDefault();

		const newITP = this.store.createRecord('IntermediateTimingPoint',
		{
			name: this.newTimingPointName,
			description: this.newTimingPointDescription,
			EventId: this.args.event,
		});

		try
		{
			await newITP.save();
		}
		catch (error)
		{
			newITP.rollbackAttributes();
			// Error is displayed by the adapter
			return;
		}

		await this.store.findRecord('IntermediateTimingPoint', newITP.id);

		this.newTimingPointName = "";
		this.newTimingPointDescription = "";
		this.isAddingNew = false;
	};
	
	@action
	cancelNew()
	{
		this.newTimingPointName = "";
		this.newTimingPointDescription = "";
		this.isAddingNew = false;
	};
	
	@action
	async save(timingPoint)
	{
		try
		{
			await timingPoint.save();
		}
		catch (error)
		{
			timingPoint.rollbackAttributes();
			// Error is displayed by the adapter
		}
	};
	
	@action
	async delete(timingPoint)
	{
		// Check if timing point has timing records assigned
		const timingRecords = this.store.peekAll('intermediate-timing-record').filter(
			record => record.IntermediateTimingPointId?.get('id') === timingPoint.id
		);
		if (timingRecords.length > 0)
		{
			this.errorManager.addError(`Cannot delete timing point "${timingPoint.name}": ${timingRecords.length} timing record(s) are assigned to it. Remove or reassign the timing records first.`, { clearable: true, type: 'validation' });
			return;
		}

		// Check if timing point is used in a course
		const courseElements = this.store.peekAll('course-element').filter(
			element => element.IntermediateTimingPointId?.get('id') === timingPoint.id
		);
		if (courseElements.length > 0)
		{
			const courseNames = [...new Set(courseElements.map(el => el.CourseId?.get('name')).filter(Boolean))].join(', ');
			this.errorManager.addError(`Cannot delete timing point "${timingPoint.name}": it is used in course(s): ${courseNames}. Remove the timing point from the course(s) first.`, { clearable: true, type: 'validation' });
			return;
		}

		const confirmed = await this.confirmation.confirm({
			title: 'Delete Timing Point',
			message: `Are you sure you want to delete the timing point "${timingPoint.name}"?`,
			confirmLabel: 'Delete',
			confirmStyle: 'danger'
		});
		if (!confirmed)
		{
			return;
		}

		try
		{
			timingPoint.deleteRecord();
			await timingPoint.save();
		}
		catch (error)
		{
			timingPoint.rollbackAttributes();
			// Error is displayed by the adapter
		}
	};
}